import React, { useEffect, useState, useContext, useRef } from 'react';
import { Form, Input, Row , Col , Radio , Select , Checkbox , Typography, DatePicker , TimePicker, message, InputNumber, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { blockedSeatTicketIdSelector, passengerInfoSelector, extraSeatInfoSelector } from './../../selector/passenger-form.selector';
import { useDispatch, useSelector } from 'react-redux';
import { isValidArray,getValuesOfJSonObject,isValid, isValidString, isValidArrayWithValues } from '../../utils/utilities';
import { getTimeStampInReadableFormat , convertDateStringToDate , getLocalDate , incrementDays , getUIDateFormat} from './../../utils/date.utils';
import {getDetailsToBookTicket,getTicketFare , PassengerSeatsTable , getAnyBlockedSeatsExit, hasRestrictedPrivilegeBlockedSeat, getPassengerDetailsByPhoneNumber, getTravellerDetails, handleFareChange } from './passenger-form.module';
import './passenger-form.style.scss';
import { bookTicket,blockTicket , onPassengerFormChange} from './../../actions/home.action';
import { CustomModal } from './../custom-components/custom-component';
import { ACTION_BOOK_TICKET_ALLOWED , ACTION_BLOCK_TICKET_ALLOWED ,ACTION_PHONE_BLOCK_ALLOWED, ACTION_TO_UPDATE_AGENT_IN_TICKET, ACTION_TO_VIEW_SET_GENDER_BTN, ACTION_UPDATE_TICKET_REMARKS, ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL, ACTION_CHANGE_BUS_ALLOWED, ACTION_RELEASE_OTA_TICKETS_ALLOWED, ACTION_UPI_BOOKING, isQBUserCheck, isSharedTripCheck} from './../../utils/constant';
import { checkActionAllowed } from './../../utils/utilities';
import { getSharingAgentActions } from './../../actions/service-sharing.actions';
import { ReleaseSeatsComponent } from './../release-seats/release-seats.component';
import { resetPassengerForm } from './../../actions/ticket.action';
import { BlockByAdminComponent } from './../block-by-admin/block-by-admin.component';
import { DeviceContext } from './../../components/device-provider/device-provider';
import { addMin ,setTimeToDateObject , getAPIDateFormat , getTimeFormat , getLocalDateAndTime} from './../../utils/date.utils';
import moment from 'moment';
import { SeatPriceComponent } from './../seat-price-component/seat-price.component';
import {
    AddDiscount,
    EditDiscount
} from './../discount-component/discount.component';
import { EditFareModal } from './../edit-fare-modal/edit-fare-modal.component';
import { getAgentNamesByOperatorCode } from '../../actions/agents.actions';
import { ChangeGenderReservation } from '../change-gender-reservation/change-gender-reservation';
import { CopyPaymentLink } from '../copy-payment-link/copy-payment-link.component';
import { onExtraSeatFormChangeAction, updateExtraSeatCount } from '../../actions/passenger-form.action';
import { SeatClickTicketPopUp } from '../ticket-summary-components/seat-click-ticket-popup.component';
import { UpiBookingComponent } from '../upi-booking/upi-booking.component';
import { agentsSelector } from '../../selector/agents.selector';
import { useHistory } from 'react-router-dom';
import { loadingAction } from '../../actions/loading-actions';
import { postCall } from '../../utils/network.util';
import { GET_TICKET_PNR_BY_ID_URL } from '../../utils/api-url';

const {
    Text
} = Typography;

let blockButtonType="Block";
let bookButtonType="Book";
let sendPaymentLink ="Send payment link";


const { Option } = Select;

const DrawLine =({className})=>{

    return(
        <div className={className}>

        </div>
    )
}

const getFirstBoardingPointId=(pickupDetails)=>{    
    if(isValidArrayWithValues(pickupDetails)){
        return pickupDetails[0].id;
    }
    return null;
}

const getFirstDropPointId=(dropDetails)=>{
    if(isValidArrayWithValues(dropDetails)){
        return dropDetails[0].id;
    }
    return null;
}

const getDropPointsDate=(selectedSchedule,selectedDate)=>{
    let destinationDayNo=0;
    if(selectedSchedule.destination_day>selectedSchedule.origin_day){
        destinationDayNo = selectedSchedule.destination_day - selectedSchedule.origin_day;
    }
    let incrementDate = incrementDays(selectedDate,destinationDayNo);
    return incrementDate;   
}

const optionValueText = (location,time,incrementDate=null) =>{
    return (
        <Row style= {{whiteSpace: 'break-spaces'}}>
            <Col span={14} >
                {location}
            </Col>
            <Col span={10} >
                {isValid(incrementDate)?time+" ("+incrementDate + ")":time}
            </Col>
        </Row>
    )
}

const getPointValue=(value,landmark)=>{
    return (<div>
                {value}
                {isValid(landmark)?
                <span style={{fontSize:11}}>
                    {landmark}
                </span>
                :null
                }
            </div>);
}

const renderBoardingsPoints=(boardingPoints,selectedDate)=>
{
    let boardingPointsArray=[] , nextDayBoardingPoints=[];
    if(isValidArray(boardingPoints)&&boardingPoints.length>0){
        boardingPoints.forEach((element,index) => {
            let desc= element.location +" " +getTimeStampInReadableFormat(element.timing);
            let timing= getTimeStampInReadableFormat(element.timing);
            if(isValid(element)){
                if(element.origin_day>0){
                    let incrementDate = getUIDateFormat(incrementDays(selectedDate,element.origin_day));
                    let value = optionValueText(element.location,timing,incrementDate)
                    desc = desc +" ("+incrementDate + ")";
                    nextDayBoardingPoints.push(<Option searchValue = {desc} value={element.id} className={[(index+1)%2==0?'point-even':'point-odd', element.pointPassed&&"passed-point"]}>
                            {getPointValue(value,element.landmark)}
                    </Option>);
                }else{
                    let value = optionValueText(element.location,timing)
                    boardingPointsArray.push(<Option searchValue = {desc} value={element.id} className={[(index+1)%2==0?'point-even':'point-odd', element.pointPassed&&"passed-point"]}>
                            {getPointValue(value,element.landmark)}
                    </Option>);
                }   
            }
        });
    }
    return boardingPointsArray.concat(nextDayBoardingPoints);
}



const renderDropPoints=(dropPoints,selectedDate,selectedSchedule)=>
{
    let dropDate = selectedDate;
    dropDate=getDropPointsDate(selectedSchedule,selectedDate);
    let dropPointsArray=[];
    if(isValidArray(dropPoints)&&dropPoints.length>0){
        dropPoints.forEach((element,index) => {
            let desc= element.location +" " +getTimeStampInReadableFormat(element.timing);
            let timing= getTimeStampInReadableFormat(element.timing);
            if(isValid(element)){
                if(element.destination_day>0||selectedSchedule.destination_day>0){
                    let incrementDate = getUIDateFormat(incrementDays(dropDate,element.destination_day));
                    let value = optionValueText(element.location,timing,incrementDate)
                    desc = desc +" ("+incrementDate + ")";
                    dropPointsArray.push(<Option searchValue = {desc} value={element.id} className={(index+1)%2==0?'point-even':'point-odd'}>
                        {getPointValue(value,element.landmark)}
                    </Option>);
                }else{
                    let value = optionValueText(element.location,timing)
                    dropPointsArray.push(<Option searchValue = {desc} value={element.id} className={(index+1)%2==0?'point-even':'point-odd'}>
                        {getPointValue(value,element.landmark)}
                    </Option>)
                }
            }        
        });
    }
    return dropPointsArray;
}

export const PassengerForm = (props) => {

    const{
        selectedSchedule,
        fetchSeats ,
        stopPoint,
        selectedDate,
        onFareUpdateSuccess
    } = props;

  const [form] = Form.useForm();
  let defalutTime = addMin(null,12).format('HH:mm:ss');
  let defalutDate = moment().utcOffset("+05:30");
  const [releaseDate , setReleaseDate] = useState(defalutDate);
  const [releaseTime , setReleaseTime] = useState(defalutTime);
  const [disableSetPrice , setDisableSetPrice] = useState(false);
  const [isPhoneBlock , setIsPhoneBlock] = useState(false);
  const [selectedSeatStatus , setSelectedSeatStatus] = useState(null);
  const [showVIPTicketReason, setShowVIPTicketReason] = useState(false);

  const dispatch=useDispatch();
  const history = useHistory();

  const {
    isDesktop
    }=useContext(DeviceContext);

  const {
      selectedSeats,
      emailId,
      phoneNumber,
      boardingId,
      dropId,
      timeOfRelease,
      remarks,
      selectedTripRoute,
      vipTicketReasons
    }=useSelector(passengerInfoSelector);

    const {
        extraSeatCount,
        extraSeatInfoList
    } = useSelector(extraSeatInfoSelector);

    const ticketId = useSelector(blockedSeatTicketIdSelector)

    let isPhoneBlockSeat= isValidString(timeOfRelease)?true:false;
    let isSendPhonePaymentLink = global.send_payment_link?true:false;

  const allAgents = useSelector(agentsSelector);
    
  const [seats,setSeats]=useState([]);
  const [formValues , setFormValues]=useState({});
  const [copyPassenger,setCopyPassengerInfo]=useState(false);
  const [boardingDropManditory,setBoardingDropManditory]=useState(true);
  const [discountValue,setDiscountValue]=useState(0);
  const [agentsList, setAgentsList] = useState({});
  const [agentCategories, setAgentCategories] = useState({
    'Self': [],
    'Online Agent': [],
    'Offline Agent': [],
    'Branch': []
  });
  const [selectedCategory, setSelectedCategory] = useState('Self');
  const [showPassengerDetails, setShowPassengerDetails] = useState(true);
  const [hideGenderFromBooking, setHideGenderFromBooking] = useState(false);
  const [hideAgeFromBooking, setHideAgeFromBooking] = useState(false);
  const [hideEmailFromBooking, setHideEmailFromBooking] = useState(false);
  const [sendNotification,setSendNotification] = useState(true);
  const [sharingAgentActions,setSharingAgentActions] = useState(null);
  const boardingPointRef = useRef(null);
  const dropPointRef = useRef(null);
  const remarksRef = useRef(null);

  // Cross operator trip: booking form buttons follow the sharing agent's permissions
  let isCrossOperatorTrip = isValid(selectedSchedule)&&isSharedTripCheck(selectedSchedule.operator_code);

  useEffect(()=>{
    setSharingAgentActions(null);
    if(isCrossOperatorTrip){
        getSharingAgentActions(selectedSchedule.operator_code,(actions)=>{
            setSharingAgentActions(actions);
        },()=>{
            setSharingAgentActions(null);
        });
    }
  },[isValid(selectedSchedule)?selectedSchedule.operator_code:null]);

  const checkFormActionAllowed=(actionName)=>{
    if(isCrossOperatorTrip){
        return isValid(sharingAgentActions)&&isValid(sharingAgentActions[actionName]);
    }
    return checkActionAllowed(actionName);
  }

  useEffect(()=>{
    if (isValid(selectedTripRoute)) {
        let tripRouteFareJSON = JSON.parse(selectedTripRoute.fare_json);
        let selectedSeatNumbers = seats.map(seat => seat.seatNumber);
        let isVipTicket = false;
        if (isValid(tripRouteFareJSON)) {
            Object.keys(tripRouteFareJSON).forEach(key => {
                if (key.startsWith(`VIP_${global.agentId}_`) && selectedSeatNumbers.includes(key.split('_')[2])) {
                    isVipTicket = true;
                }
            });
            if (isVipTicket) {
                setShowVIPTicketReason(true);
            }
            else {
                setShowVIPTicketReason(false);
            }
        }
    }
  },[selectedTripRoute, seats]);
  // Navigation function for extra seat remarks
  const navigateToNextExtraSeatOrBoardingPoint = (currentExtraSeatIndex) => {
    // Check if there are more extra seats
    if (currentExtraSeatIndex < extraSeatCount - 1) {
        const nextExtraSeatNameInput = document.querySelector(`input[name="extraSeatDetails[${currentExtraSeatIndex + 1}].extra_fullName"]`);
        if (nextExtraSeatNameInput) {
            nextExtraSeatNameInput.focus();
            return;
        }
    }
    
    // No more extra seats, move to boarding point
    else{
        setTimeout(() => {
            if (boardingPointRef.current) {
                boardingPointRef.current.focus();
            } else {
                const boardingPointSelect = document.querySelector('.boarding-point-select-style');
                if (boardingPointSelect) {
                    boardingPointSelect.click();
                }
            }
        }, 100);
    }
  };
  
  // Navigation function for after drop point selection
  const navigateToNextFieldAfterDropPoint = () => {
    // Check if remarks field is enabled and visible
    if (global.useRemarks === 1 && checkActionAllowed(ACTION_UPDATE_TICKET_REMARKS)) {
      if (remarksRef.current) {
        remarksRef.current.focus();
        return;
      }
    }
    
    // Check if email field is enabled and visible
    if (!hideEmailFromBooking) {
      let emailInput = document.querySelector('input[name="emailId"]');
      
      if (!emailInput) {
        // Try alternative selectors
        emailInput = document.querySelector('input[placeholder*="Email"], input[placeholder*="email"]');
      }
      
      if (emailInput) {
        emailInput.focus();
        return;
      }
    }
    
    // No further navigation after remarks and email
  };

  const updateAgentList = (agentData) => {
    let categorizedAgents = {
        'Self': [],
        'Online Agent': [],
        'Offline Agent': [],
        'Branch': []
    };

    agentData.forEach((data) => {
        let privilege = data.privilege.toLowerCase();

        if (privilege === 'offline agent') {
            categorizedAgents['Offline Agent'].push(data);
        } else if (privilege.includes('office')) {
            categorizedAgents['Branch'].push(data);
        } else if (privilege.includes('agent')) {
            categorizedAgents['Online Agent'].push(data);
        }
    });

    setAgentCategories(categorizedAgents);
    setSelectedCategory('Self');
    setAgentsList(null);
  }

  useEffect(()=>{
    if(isValidArrayWithValues(allAgents)){
      updateAgentList(allAgents);
    }
  },[allAgents]);

  let isAnyBlockedSeatExits=getAnyBlockedSeatsExit(seats);
  let hideActionsForRestrictedPrivilege=hasRestrictedPrivilegeBlockedSeat(seats);

  useEffect(() => {
      if (checkActionAllowed(ACTION_TO_UPDATE_AGENT_IN_TICKET)){
        getAgentNamesByOperatorCode(updateAgentList,(err)=> {});
      }
      else {
          setAgentsList(null);
      }
      setHideGenderFromBooking(global.travelsAppConfig['HIDE_GENDER_FROM_BOOKING']==1);
      setHideAgeFromBooking(global.travelsAppConfig['HIDE_AGE_FROM_BOOKING']==1);
      setHideEmailFromBooking(global.travelsAppConfig['HIDE_EMAIL_FROM_BOOKING']==1);
  },[])

  useEffect(()=>{
    if(isValid(timeOfRelease)){
        setReleaseDate(moment(getAPIDateFormat(timeOfRelease)));
        setReleaseTime(getTimeFormat(timeOfRelease));
    }else{
        setReleaseDate(defalutDate);
        setReleaseTime(defalutTime);
    }
  },[timeOfRelease]);

  useEffect(() => {
    if(!isValidArray(selectedSchedule)||!isValidArray(selectedSchedule.trip)||!isValid(selectedSchedule.trip.id)||!isValidArrayWithValues(seats)){
        setShowPassengerDetails(false);
    }
    else {
        setShowPassengerDetails(true);
    }
  }, [selectedSchedule, seats])

  useEffect(()=>{
      let seatsArray=getValuesOfJSonObject(selectedSeats);
      setSeats(seatsArray);
      let tempSeatStatus = null;
      let passengerDetails = seatsArray.map(seat => {
        tempSeatStatus = seat.seatStatus;
        return {
          ...seat,
          gender: seat.gender || 'M'
        };
      });
      setSelectedSeatStatus(tempSeatStatus);
    form.setFieldsValue({
        passengerDetails:passengerDetails
    });

    // Handle initial navigation - focus on phone number input
    if(seatsArray.length > 0) {
        setTimeout(() => {
            const phoneInput = document.querySelector('input[name="phoneNumber"]');
            if (phoneInput) {
                phoneInput.focus();
            }
        }, 500); // Delay to ensure form is fully rendered
    }

    if(seatsArray.length === 0){
        setDisableSetPrice(false);
    }
  },[selectedSeats])

  useEffect(()=>{
    if(isValidArrayWithValues(extraSeatInfoList)) {
        form.setFieldsValue({
            extraSeatDetails:extraSeatInfoList
        });
    }
  },[extraSeatCount])

  useEffect(()=>{
    let formInfo = {};
    if(isValid(emailId)){   
        formInfo.emailId = emailId;
    }
    if(isValid(phoneNumber)){
        formInfo.phoneNumber = phoneNumber;
    }
    if(isValid(boardingId)){
        formInfo.boardingPointId = boardingId;
    }
    if(isValid(dropId)){
        formInfo.dropPointId = dropId;
    }
    if(isValid(remarks)){
        formInfo.remarks = remarks;
    }
    form.setFieldsValue(formInfo)
  },[emailId,phoneNumber,boardingId,dropId,remarks])

  // Set default boarding and drop points when stopPoint data becomes available
  useEffect(() => {
    resetForm();
    if (stopPoint && stopPoint.pickupDetails && stopPoint.dropDetails) {
      const defaultBoardingPointId = getFirstBoardingPointId(stopPoint.pickupDetails);
      const defaultDropPointId = getFirstDropPointId(stopPoint.dropDetails);
      
      // Only set if form fields are currently null/empty
      const currentValues = form.getFieldsValue();
      if (!currentValues.boardingPointId && defaultBoardingPointId) {
        form.setFieldsValue({boardingPointId:defaultBoardingPointId});
      }
      if (!currentValues.dropPointId && defaultDropPointId) {
        form.setFieldsValue({dropPointId: defaultDropPointId});
      }
    }
  }, [stopPoint]);


  const handleSubmit =  (e , buttonType) => {
    e.preventDefault();
    if(buttonType===bookButtonType||buttonType===sendPaymentLink){
        setBoardingDropManditory(true);
    }else{
        setBoardingDropManditory(false);
    }
    return form.validateFields()
    .then(values => {
        // Validate boarding point ID exists in stopPoint.pickupDetails
        if(values.boardingPointId && isValidArrayWithValues(stopPoint.pickupDetails)){
            const boardingPointExists = stopPoint.pickupDetails.some(point => point.id === values.boardingPointId);
            if(!boardingPointExists){
                message.error('Selected boarding point is not valid');
                return false;
            }
        }

        // Validate drop point ID exists in stopPoint.dropDetails
        if(values.dropPointId && isValidArrayWithValues(stopPoint.dropDetails)){
            const dropPointExists = stopPoint.dropDetails.some(point => point.id === values.dropPointId);
            if(!dropPointExists){
                message.error('Selected drop point is not valid');
                return false;
            }
        }
        
        setFormValues(values);
      return true;
    }).catch((err)=>{
      return false;
    })
}

const onSuccess=()=>{
    fetchSeats(selectedSchedule.trip_route_id);
    resetForm();
    dispatch(resetPassengerForm());
    setDiscountValue(0);
}

const onBookFailure = (loadSeats) => {
    if (loadSeats) {
        fetchSeats(selectedSchedule.trip_route_id);
    }
}

const bookAction=()=>{
    form.validateFields()
    .then(values => {
        dispatch(bookTicket(getDetailsToBookTicket(values,selectedSchedule,null,false,discountValue,ticketId,sendNotification),onSuccess, onBookFailure));
    })
    .catch((err)=>{
        console.log(err);
    })
}

const blockAction =(buttonType)=>{
    let datetime = null ;
    let isSendPaymentLink = false;
    form.validateFields()
    .then(values => {                
        if((isPhoneBlock || buttonType === sendPaymentLink) && isValid(releaseDate)){
            datetime =  setTimeToDateObject(releaseDate,releaseTime) ; 
            if(buttonType === sendPaymentLink){
                isSendPaymentLink = true;
            }
        }
        dispatch(blockTicket(getDetailsToBookTicket(values,selectedSchedule,datetime , isSendPaymentLink,discountValue,ticketId,false),onSuccess));
    })
    .catch((err)=>{
        console.log(err);
    })
}

const resetForm=()=>{
    form.setFieldsValue({
        passengerDetails:[],
        phoneNumber:null,
        emailId:null,
        boardingPointId:null,
        dropPointId:null,
        remarks:null
    })
}

const goToModifyCancelByTicketId = async () => {
    if(!isValid(ticketId)){
        message.error("Unable to open modify/cancel: ticket not found for selected seat.");
        return;
    }
    dispatch(loadingAction(true));
    try{
        const data = await postCall(GET_TICKET_PNR_BY_ID_URL, { ticketId: ticketId });
        if (data?.status === "SUCCESS" && data?.payload?.Status === "SUCCESS" && isValid(data?.payload?.Payload?.pnr)) {
            const pnr = data.payload.Payload.pnr;
            const openChangeBus = checkActionAllowed(ACTION_CHANGE_BUS_ALLOWED) || isQBUserCheck();
            history.push('/view-cancel?pnr=' + pnr + (openChangeBus ? '&changeBus=1' : ''));
        } else {
            message.error(data?.payload?.Message || "Unable to fetch PNR for selected ticket.");
        }
    } catch (e) {
        console.error(e);
        message.error("Unable to open modify/cancel right now. Please try again.");
    } finally {
        dispatch(loadingAction(false));
    }
}

const onFormChange=({
    fullName,
    age,
    gender,
    seatId
})=>{
    dispatch(onPassengerFormChange({
        fullName,
        age,
        gender,
        seatId
    }))
}

const onExtraSeatFormChange = (data) => {
    dispatch(onExtraSeatFormChangeAction({...data}));
}

const ConfirmBody=({isShowMins,setSendNotification,sendNotification,buttonType})=>{    
    return (
        <div>
            <Row>
                <h3>
                    Confirm Booking
                </h3>
            </Row>
            <Row>
                <DrawLine className={"confirm-booking-underline marginBottom"}/>
            </Row>
            <Row>
                <Col>
                    <Text>
                        <Text strong>Travel Date : </Text>
                        {getLocalDate(convertDateStringToDate(selectedSchedule.trip.start_date.split("T")[0]))}
                    </Text>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Text>
                        <Text strong>Trip Description : </Text>
                        {selectedSchedule.description}
                    </Text>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Text>
                        <Text strong>No of seats : </Text>
                        {seats.length}
                    </Text>
                </Col>
            </Row>
            {isValid(global.travelsAppConfig['EXTRA_SEAT_BOOKING'])&&global.travelsAppConfig['EXTRA_SEAT_BOOKING']==1&&checkActionAllowed('EXTRA_SEATS_BOOKING_ALLOWED')&&
                <Row>
                    <Col>
                        <Text>
                            <Text strong>No of extra seats : </Text>
                            {extraSeatCount}
                        </Text>
                    </Col>
                </Row>
            }
            <div>
                <PassengerSeatsTable 
                    formValues={formValues}
                    boardingPoints={stopPoint.pickupDetails}
                    discountValue={discountValue}
                    bus={selectedSchedule.bus}
                />
            </div>
            {isShowMins &&
                <Row gutter={[16,16]}>
                    <Col style={{ textAlign: 'center',marginTop: '15px' }}>
                            <Checkbox
                                checked={isPhoneBlock}
                                onChange={(e) => setIsPhoneBlock(e.target.checked)}
                            />
                    </Col>
                    <Col>
                        <DatePicker 
                            className='marginLeft marginTop'
                            placeholder="Select date"
                            defaultValue={defalutDate}
                            value={releaseDate}
                            format="DD-MM-YYYY"
                            onChange={(date)=>{
                                if(isValid(date)){
                                    setReleaseDate(date);
                                }else{
                                    setReleaseDate(moment().utcOffset("+05:30"));
                                }
                            }}
                            />
                        <TimePicker 
                            className='marginLeft marginTop remove-clear-icon'  
                            placeholder='"Select time'
                            defaultValue={moment(defalutTime, 'HH:mm:ss')}
                            value={moment(releaseTime, 'HH:mm:ss')}
                            use12Hours 
                            format="h:mm A" 
                            onChange={(time,timeString)=>{
                                if(isValid(time)){
                                    setReleaseTime(time.format('HH:mm:ss'));
                                }else{
                                    setReleaseTime('00:00:00');
                                }
                            }} 
                            style={{ width: 140 }}
                            />
                    </Col>
                </Row>
            }
            {checkActionAllowed(ACTION_TO_UPDATE_AGENT_IN_TICKET) && (
                <Row className="marginTop" gutter={[16,16]}>
                    <Col span={10}>
                        <Form.Item
                            label={<strong>Book as</strong>}
                            rules={[{ required: false, message: 'Please select category' }]}
                        >
                            <Select
                                size="large"
                                showSearch
                                value={selectedCategory}
                                placeholder="Select Category"
                                onChange={(value) => {
                                    setSelectedCategory(value);
                                    if (value === 'Self') {
                                        setAgentsList(null);
                                        form.setFieldsValue({ agentId: global.agentId });
                                    } else {
                                        setAgentsList(agentCategories[value]);
                                        form.setFieldsValue({ agentId: null });
                                    }
                                }}
                                bordered={true}
                                style={{minWidth: '150px'}}
                            >
                                {Object.keys(agentCategories).map(category => (
                                    <Option key={category} value={category}>{category}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    {selectedCategory !== 'Self' && (
                        <Col span={12}>
                            <Form.Item
                                label={<strong>Select User</strong>}
                                rules={[{ required: false, message: 'Please select an agent' }]}
                                name="agentId"
                            >
                                <Select
                                    size="large"
                                    showSearch
                                    defaultValue={global.agentId}
                                    placeholder="Select User"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    bordered={true}
                                    disabled={!selectedCategory || selectedCategory === 'Self'}
                                    style={{minWidth: '150px'}}
                                >
                                    {agentsList.map(agent => (
                                        <Option key={agent.id} value={agent.id}>{agent.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}
                </Row>
            )}
            {buttonType == bookButtonType&&
            <Row>
                <Col>
                    <Checkbox checked={sendNotification} onChange={(e)=>setSendNotification(e.target.checked)}>Send Notification</Checkbox>  
                </Col>
            </Row>
            }
        </div>
    )
}

let {
    baseFare,
    cgst,sgst,
    discountedCostWithoutGst,
    totalCost
} = getTicketFare(seats,discountValue,selectedSchedule.bus, extraSeatInfoList);
   
let isDiscountExits=baseFare>discountedCostWithoutGst?true:false;

const handleEnterKeyNavigation = (currentElement) => {
    const currentInput = currentElement;
    const currentClassName = currentInput.className;
    
    // Check if current input is a passenger name input
    if (currentClassName.includes('passengerNameInput')) {
        // Find the current passenger index from the input's name attribute or parent structure
        const passengerIndex = getCurrentPassengerIndex(currentInput);
        
        if (passengerIndex !== -1) {
            // Navigate based on hideGenderFromBooking and hideAgeFromBooking conditions
            if (!hideGenderFromBooking) {
                // Move to Gender selection
                const genderSelect = document.querySelector(`select[name="passengerDetails[${passengerIndex}].gender"]`);
                if (genderSelect) {
                    genderSelect.focus();
                    return;
                }
            } else if (!hideAgeFromBooking) {
                // Skip gender, move to Age input
                const ageInput = document.querySelector(`input[name="passengerDetails[${passengerIndex}].age"]`);
                if (ageInput) {
                    ageInput.focus();
                    return;
                }
            } else {
                // Both gender and age are hidden, move to next passenger or boarding point
                navigateToNextPassengerOrBoardingPoint(passengerIndex);
                return;
            }
        }
    }
    
    // Check if current input is a gender select
    if (currentInput.tagName === 'SELECT' && currentInput.name && currentInput.name.includes('gender')) {
        const passengerIndex = getCurrentPassengerIndex(currentInput);
        
        if (passengerIndex !== -1 && !hideAgeFromBooking) {
            // Move to Age input
            const ageInput = document.querySelector(`input[name="passengerDetails[${passengerIndex}].age"]`);
            if (ageInput) {
                ageInput.focus();
                return;
            }
        } else {
            // Age is hidden, move to next passenger or boarding point
            navigateToNextPassengerOrBoardingPoint(passengerIndex);
            return;
        }
    }
    
    // Check if current input is an age input
    if (currentClassName.includes('ageInput') && currentInput.name && currentInput.name.includes('age')) {
        const passengerIndex = getCurrentPassengerIndex(currentInput);
        navigateToNextPassengerOrBoardingPoint(passengerIndex);
        return;
    }
    
    // Default behavior for other inputs
    const inputs = Array.from(document.querySelectorAll('input:not([type="radio"]), input[type="radio"]:checked, select'));
    const index = inputs.indexOf(currentInput);
    if (index > -1 && index < inputs.length - 1) {
        inputs[index + 1].focus();
    }
};

const getCurrentPassengerIndex = (element) => {
    // Try to extract passenger index from the element's name attribute
    if (element.name) {
        const match = element.name.match(/passengerDetails\[(\d+)\]/);
        if (match) {
            return parseInt(match[1]);
        }
    }
    
    // Fallback: find the index by looking at the parent structure
    const passengerBlock = element.closest('.passenger-block');
    if (passengerBlock) {
        const allPassengerBlocks = document.querySelectorAll('.passenger-block');
        return Array.from(allPassengerBlocks).indexOf(passengerBlock);
    }
    
    return -1;
};

const navigateToNextPassengerOrBoardingPoint = (currentPassengerIndex) => {
    const totalPassengers = seats.length;
    
    // Check if there are more passengers
    if (currentPassengerIndex < totalPassengers - 1) {
        // Move to next passenger's name input - try multiple selectors
        let nextPassengerNameInput = document.querySelector(`input[name="passengerDetails[${currentPassengerIndex + 1}].fullName"]`);
        if (!nextPassengerNameInput) {
            // Fallback: find by class and index
            const allPassengerNameInputs = document.querySelectorAll('.passengerNameInput');
            if (allPassengerNameInputs[currentPassengerIndex + 1]) {
                nextPassengerNameInput = allPassengerNameInputs[currentPassengerIndex + 1];
            }
        }
        if (nextPassengerNameInput) {
            nextPassengerNameInput.focus();
            return;
        }
    }
    // No more passengers, check for extra seats first
    if (extraSeatCount > 0) {
        // Use a retry mechanism with delay to find extra seat input
        const findExtraSeatInput = (attempt = 0) => {
            if (attempt > 3) {
                return;
            }
            
            // Try multiple selectors for extra seat name input
            let firstExtraSeatNameInput = document.querySelector(`input[name="extraSeatDetails[0].extra_fullName"]`);
            
            if (!firstExtraSeatNameInput) {
                // Try alternative selector
                firstExtraSeatNameInput = document.querySelector('input[placeholder="Name"]');
            }
            
            if (!firstExtraSeatNameInput) {
                // Try to find within extra seat form list by looking for the h3 with "Extra Seat Details"
                const extraSeatHeading = document.querySelector('h3');
                if (extraSeatHeading && extraSeatHeading.textContent.includes('Extra Seat Details')) {
                    const extraSeatFormList = extraSeatHeading.parentElement;
                    firstExtraSeatNameInput = extraSeatFormList.querySelector('input[placeholder="Name"]');
                }
            }
            
            if (!firstExtraSeatNameInput) {
                // Last resort: find all inputs with "Name" placeholder and get the first one after regular passengers
                const allNameInputs = document.querySelectorAll('input[placeholder="Name"]');
                if (allNameInputs.length > 0) {
                    // Find the first one that's not a regular passenger
                    for (let i = 0; i < allNameInputs.length; i++) {
                        const input = allNameInputs[i];
                        const name = input.getAttribute('name');
                        if (name && name.includes('extraSeatDetails')) {
                            firstExtraSeatNameInput = input;
                            break;
                        }
                    }
                }
            }
            
            if (firstExtraSeatNameInput) {
                firstExtraSeatNameInput.focus();
                return;
            } else {
                setTimeout(() => findExtraSeatInput(attempt + 1), 200);
            }
        };
        
        // Start the search with a delay to ensure extra seat form is rendered
        setTimeout(() => findExtraSeatInput(), 200);
        return;
    }
    
    // No extra seats, move to boarding point
    // Use ref-based approach first, then fallback to DOM query
    else{
        setTimeout(() => {
            if (boardingPointRef.current) {
                boardingPointRef.current.focus();
            } else {
                // Fallback: find and click the boarding point select
                const boardingPointSelect = document.querySelector('.boarding-point-select-style');
                
                if (boardingPointSelect) {
                    // Click to open the dropdown
                    boardingPointSelect.click();
                }
            }
        }, 300);
    }
    
};

if (!showPassengerDetails&&extraSeatCount<1) {
    return null
}
  return (
    <div>
        {showPassengerDetails&&<><h3>Passenger Details</h3>
        <DrawLine className={"passenger-details-underline"}/>
        </>}
        <Form
        form={form}
        layout="vertical"
        initialValues={{ 
            passengerDetails: [], 
            extraSeatDetails: [],
            'boardingPointId':getFirstBoardingPointId(stopPoint.pickupDetails),
            'dropPointId':getFirstDropPointId(stopPoint.dropDetails),
            'passengerDetails[0].gender': 'M',
            'passengerDetails[1].gender': 'M',
            'passengerDetails[2].gender': 'M',
            'passengerDetails[3].gender': 'M',
            'passengerDetails[4].gender': 'M'
        }}
        onKeyPress={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleEnterKeyNavigation(e.target);
            }
        }}
        onValuesChange={(changedValues,allValues)=>{
            let allPassengerDetails=allValues.passengerDetails;
            let changedPassengerDetails=changedValues.passengerDetails;
            if(isValidArrayWithValues(allPassengerDetails)&&copyPassenger&&isValidArray(changedPassengerDetails)){
                for (let index = 0; index < changedPassengerDetails.length; index++) {
                    if(isValidArray(changedPassengerDetails[index])){
                        let {
                            fullName,
                            age
                        }=changedPassengerDetails[index];
                        for (let j = 0; j < allPassengerDetails.length; j++) {
                            if(isValid(fullName)){
                                allPassengerDetails[j].fullName=fullName;
                            }else if(isValid(age)){
                                allPassengerDetails[j].age=age;
                            }    
                        }
                        break;
                    }
                }
                form.setFieldsValue({
                    passengerDetails:[...allPassengerDetails]
                });
            }
        }}
        >
            <Row gutter={16}>
                <Col>
                    <Form.Item 
                     label={<strong>Phone no</strong>} 
                     rules={[{ required: boardingDropManditory, message: 'Please enter customer phone no' }]}
                     tooltip="Please enter customer phone no"
                     name="phoneNumber"
                     >
                        <Input.Search 
                        placeholder="Phone no" 
                        className="defalut-input-style phoneNumberInput" 
                        maxLength={10}
                        onSearch={(value)=>{
                            getPassengerDetailsByPhoneNumber(value,(ticket,travellers)=>{
                                let formatedPassengerDetails = [];
                                let seatsArray = getValuesOfJSonObject(selectedSeats);
                                          
                                for (let index = 0; index < seatsArray.length; index++) {
                                    const passenger = getTravellerDetails(travellers,index);
                                    
                                    if(isValidArray(passenger)){
                                        formatedPassengerDetails.push({
                                            ...seatsArray[index],
                                            fullName:passenger.full_name,
                                            age:passenger.age,
                                            gender:passenger.gender
                                        });
                                    }else{
                                        formatedPassengerDetails.push({
                                            ...seatsArray[index]
                                        });
                                    }
                                }                                
                                form.setFieldsValue({
                                    emailId:ticket.email_id,
                                    // we might have diffrent trip booking
                                    // boardingPointId:ticket.pickup_location,
                                    // dropPointId:ticket.drop_location
                                    passengerDetails:formatedPassengerDetails
                                });

                            });
                            
                            // Navigate to first passenger name after phone search
                            setTimeout(() => {
                                let passengerNameInput = document.querySelector(`input[name="passengerDetails[0].fullName"]`);
                                if (!passengerNameInput) {
                                    const allPassengerNameInputs = document.querySelectorAll('.passengerNameInput');
                                    if (allPassengerNameInputs[0]) {
                                        passengerNameInput = allPassengerNameInputs[0];
                                    }
                                }
                                if (passengerNameInput) {
                                    passengerNameInput.focus();
                                }
                            }, 200);
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                setTimeout(() => {
                                    let passengerNameInput = document.querySelector(`input[name="passengerDetails[0].fullName"]`);
                                    if (!passengerNameInput) {
                                        const allPassengerNameInputs = document.querySelectorAll('.passengerNameInput');
                                        if (allPassengerNameInputs[0]) {
                                            passengerNameInput = allPassengerNameInputs[0];
                                        }
                                    }
                                    if (passengerNameInput) {
                                        passengerNameInput.focus();
                                    }
                                }, 100);
                            }
                        }}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {showPassengerDetails&&<>
                <div className='copy-same-name-txt'>
                    <Checkbox 
                        value={copyPassenger}
                        onChange={(e)=>{
                        setCopyPassengerInfo(e.target.checked);
                        if(e.target.checked){
                        let passengerDetails=form.getFieldValue('passengerDetails');
                            for (let index = 1; index < passengerDetails.length; index++) {
                                passengerDetails[index].fullName=passengerDetails[0].fullName;
                                passengerDetails[index].age=passengerDetails[0].age;
                            }
                            form.setFieldsValue({
                                passengerDetails:[...passengerDetails]
                            })
                        }
                    }}
                    >Copy same name and age</Checkbox>
                </div>
            <Form.List name="passengerDetails">
            {(fields, { add, remove }) => (
                <>
            {fields.map(({ key, name, id,fieldKey, ...restField }) => {
                let isShowLabel = key==0&&isDesktop?true:false;
                return(
                    <div>
                        <div className="passenger-block">
                            <Row gutter={[16,16]}>
                                <Col>
                                    <Form.Item
                                        label={isShowLabel?<strong>Seat #</strong>:null}
                                        {...restField}
                                        name={[name, 'seatNumber']}
                                        fieldKey={[fieldKey, 'seatNumber']}
                                        rules={[{ required: false, message: 'Please enter seat number' }]}
                                    >
                                        <Input placeholder="Seat #" disabled={true} className="seatNumberInput" />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item
                                        label={isShowLabel?<strong>Passenger name</strong>:null}
                                        {...restField}
                                        name={[name, 'fullName']}
                                        fieldKey={[fieldKey, 'fullName']}
                                        rules={[{ 
                                            required: boardingDropManditory,
                                            message: '',
                                            pattern: new RegExp(/^[a-zA-Z0-9\s\.]*$/)
                                        }]}
                                        tooltip="Only English alphabets, numbers and space are allowed"
                                    >
                                        <Input 
                                        placeholder="Passenger Name" 
                                        className="passengerNameInput" 
                                        onChange={(e)=>{
                                            onFormChange({fullName:e.target.value,seatId:seats[key].id})
                                        }}
                                        />
                                    </Form.Item>
                                </Col>
                                {!hideGenderFromBooking&&<Col>
                                    <Form.Item
                                        {...restField}
                                        label={isShowLabel?<strong>Gender</strong>:null}
                                        name={[name, 'gender']}
                                        fieldKey={[fieldKey, 'gender']}
                                        rules={[{ required: true, message: '' }]}
                                    >
                                        <Select
                                            placeholder="Gender"
                                            onChange={(value)=>{
                                                onFormChange({gender:value,seatId:seats[key].id})
                                                // Auto-navigate to next field after gender selection
                                                setTimeout(() => {
                                                    if (!hideAgeFromBooking) {
                                                        // Move to Age input - try multiple selectors
                                                        let ageInput = document.querySelector(`input[name="passengerDetails[${key}].age"]`);
                                                        if (!ageInput) {
                                                            // Fallback: find by class and passenger index
                                                            const allAgeInputs = document.querySelectorAll('.ageInput');
                                                            if (allAgeInputs[key]) {
                                                                ageInput = allAgeInputs[key];
                                                            }
                                                        }
                                                        if (ageInput) {
                                                            ageInput.focus();
                                                        }
                                                    } else {
                                                        // Age is hidden, move to next passenger or boarding point
                                                        navigateToNextPassengerOrBoardingPoint(key);
                                                    }
                                                }, 200); // Increased delay to ensure the select has closed
                                            }}
                                            onDropdownVisibleChange={(open) => {
                                                // Handle when dropdown is closed (open = false)
                                                if (!open) {
                                                    setTimeout(() => {
                                                        const currentValue = form.getFieldValue(['passengerDetails', key, 'gender']);
                                                        if (currentValue === 'M' && !hideAgeFromBooking) {
                                                            // Default male is selected, move to age input
                                                            let ageInput = document.querySelector(`input[name="passengerDetails[${key}].age"]`);
                                                            if (!ageInput) {
                                                                const allAgeInputs = document.querySelectorAll('.ageInput');
                                                                if (allAgeInputs[key]) {
                                                                    ageInput = allAgeInputs[key];
                                                                }
                                                            }
                                                            if (ageInput) {
                                                                ageInput.focus();
                                                            }
                                                        }
                                                    }, 100);
                                                }
                                            }}
                                            onBlur={() => {
                                                // Handle default selection when focus is lost (user moved away from gender)
                                                setTimeout(() => {
                                                    const currentValue = form.getFieldValue(['passengerDetails', key, 'gender']);
                                                    if (currentValue === 'M' && !hideAgeFromBooking) {
                                                        // Default male is selected, move to age input
                                                        let ageInput = document.querySelector(`input[name="passengerDetails[${key}].age"]`);
                                                        if (!ageInput) {
                                                            const allAgeInputs = document.querySelectorAll('.ageInput');
                                                            if (allAgeInputs[key]) {
                                                                ageInput = allAgeInputs[key];
                                                            }
                                                        }
                                                        if (ageInput) {
                                                            ageInput.focus();
                                                        }
                                                    }
                                                }, 100);
                                            }}
                                            style={{ width: 100 }}
                                            defaultValue="M"
                                        >
                                            <Option value="M">Male</Option>
                                            <Option value="F">Female</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>}
                                {!hideAgeFromBooking&&<Col>
                                        <Form.Item
                                            {...restField}
                                            label={isShowLabel?<strong>Age</strong>:null}
                                            name={[name, 'age']}
                                            fieldKey={[fieldKey, 'age']}
                                            rules={[{
                                                required: boardingDropManditory, 
                                                pattern: new RegExp(/^[0-9]*$/),
                                                message: '' }]}
                                            tooltip="Only numbers are allowed"
                                            >
                                            <Input placeholder={"Age"}  className="ageInput"
                                            onChange={(e)=>{
                                                onFormChange({age:e.target.value,seatId:seats[key].id})
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    navigateToNextPassengerOrBoardingPoint(key);
                                                }
                                            }}
                                            />
                                        </Form.Item>
                                </Col>}
                                <Col>
                                    <Form.Item
                                        label={key==0?<span className="fare-label-with-edit">
                                        <EditFareModal
                                        showEditFare={checkFormActionAllowed(ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL)}
                                        selectedSeats={seats} onFareChange={(updatedFares, isVip) => {
                                            handleFareChange(updatedFares, selectedSchedule, dispatch, isVip);
                                        }} disabled={disableSetPrice} />
                                        </span>:null}
                                        {...restField}
                                        name={[name, 'discountedCostWithoutGst']}
                                        fieldKey={[fieldKey, 'discountedCostWithoutGst']}
                                        rules={[{ required: false, message: 'Please enter seat number' }]}
                                    >
                                        <Input placeholder="fare" disabled={true} className={`fareInput ${key!=0&&checkFormActionAllowed(ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL) ? 'give-margin-support-label' : ''}`} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    )})}
                </>
                )}
            </Form.List>
            </>}
            {isValid(global.travelsAppConfig['EXTRA_SEAT_BOOKING'])&&global.travelsAppConfig['EXTRA_SEAT_BOOKING']==1&&checkActionAllowed('EXTRA_SEATS_BOOKING_ALLOWED')&&extraSeatCount>0&&
            <div>
                <h3>Extra Seat Details</h3>
                <Form.List name="extraSeatDetails">
                    {(fields, {add, remove}) => (
                        <>
                            {fields.map(({key, name, id, fieldKey, ...restField}) => {
                                let isShowLabel = key==0&&isDesktop?true:false;
                                return (
                                    <div>
                                        <Row gutter={[16,16]}>
                                            <Col>
                                                <Form.Item
                                                    label={isShowLabel?<strong>Name</strong>:null}
                                                    {...restField}
                                                    name={[name, 'extra_fullName']}
                                                    fieldKey={[fieldKey, 'extra_fullName']}
                                                    rules={[{
                                                        required: true,
                                                        message: '',
                                                        pattern: new RegExp(/^[a-zA-Z0-9\s\.]*$/)
                                                    }]}
                                                    tooltip="Only English alphabets, numbers and space are allowed"
                                                >
                                                    <Input
                                                        placeholder="Name"
                                                        className="passengerNameInput"
                                                        onChange={(e)=>{
                                                            onExtraSeatFormChange({extra_fullName:e.target.value, extra_index: name})
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            {!hideGenderFromBooking&&<Col>
                                                <Form.Item
                                                    {...restField}
                                                    label={isShowLabel?<strong>Gender</strong>:null}
                                                    name={[name, 'extra_gender']}
                                                    fieldKey={[fieldKey, 'extra_gender']}
                                                    rules={[{ required: false, message: '' }]}
                                                >
                                                    <Select
                                                        placeholder="Gender"
                                                        onChange={(value)=>{
                                                            onExtraSeatFormChange({extra_gender:value, extra_index: name})
                                                            // Auto-navigate to next field after gender selection
                                                            setTimeout(() => {
                                                                if (!hideAgeFromBooking) {
                                                                    // Move to Age input for extra seat - try multiple selectors
                                                                    let ageInput = document.querySelector(`input[name="extraSeatDetails[${name}].extra_age"]`);
                                                                    if (!ageInput) {
                                                                        // Fallback: find by class and index
                                                                        const allExtraAgeInputs = document.querySelectorAll('.extraSeatAgeInput');
                                                                        if (allExtraAgeInputs[name]) {
                                                                            ageInput = allExtraAgeInputs[name];
                                                                        }
                                                                    }
                                                                    if (ageInput) {
                                                                        ageInput.focus();
                                                                    }
                                                                } else {
                                                                    // Age is hidden, move to next field (fare input)
                                                                    const fareInput = document.querySelector(`input[name="extraSeatDetails[${name}].extra_fare"]`);
                                                                    if (fareInput) {
                                                                        fareInput.focus();
                                                                    }
                                                                }
                                                            }, 200); // Increased delay to ensure the select selection is processed
                                                        }}
                                                        onDropdownVisibleChange={(open) => {
                                                            if (!open) {
                                                                setTimeout(() => {
                                                                    const currentValue = form.getFieldValue(['extraSeatDetails', name, 'extra_gender']);
                                                                    if (currentValue === 'M' && !hideAgeFromBooking) {
                                                                        // Default male is selected, move to age input
                                                                        let ageInput = document.querySelector(`input[name="extraSeatDetails[${name}].extra_age"]`);
                                                                        if (!ageInput) {
                                                                            const allExtraAgeInputs = document.querySelectorAll('.extraSeatAgeInput');
                                                                            if (allExtraAgeInputs[name]) {
                                                                                ageInput = allExtraAgeInputs[name];
                                                                            }
                                                                        }
                                                                        if (ageInput) {
                                                                            ageInput.focus();
                                                                        }
                                                                    }
                                                                }, 100);
                                                            }
                                                        }}
                                                        onBlur={() => {
                                                            if (!hideAgeFromBooking) {
                                                                setTimeout(() => {
                                                                    const currentValue = form.getFieldValue(['extraSeatDetails', name, 'extra_gender']);
                                                                    if (currentValue === 'M' && !hideAgeFromBooking) {
                                                                        // Default male is selected, move to age input
                                                                        let ageInput = document.querySelector(`input[name="extraSeatDetails[${name}].extra_age"]`);
                                                                        if (!ageInput) {
                                                                            const allExtraAgeInputs = document.querySelectorAll('.extraSeatAgeInput');
                                                                            if (allExtraAgeInputs[name]) {
                                                                                ageInput = allExtraAgeInputs[name];
                                                                            }
                                                                        }
                                                                        if (ageInput) {
                                                                            ageInput.focus();
                                                                        }
                                                                    }
                                                                }, 100);
                                                            }
                                                        }}
                                                        style={{ width: 100 }}
                                                        defaultValue="M"
                                                    >
                                                        <Option value="M">Male</Option>
                                                        <Option value="F">Female</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>}
                                            {!hideAgeFromBooking&&<Col>
                                                <Form.Item
                                                    label={isShowLabel?<strong>Age</strong>:null}
                                                    name={[name, 'extra_age']}
                                                    fieldKey={[fieldKey, 'extra_age']}
                                                    rules={[{
                                                        required: false,
                                                        pattern: new RegExp(/^[0-9]*$/),
                                                        message: '' }]}
                                                    tooltip="Only numbers are allowed"
                                                >
                                                    <Input
                                                        placeholder="Age"
                                                        className="extraSeatAgeInput"
                                                        onChange={(e)=>{
                                                            onExtraSeatFormChange({extra_age:e.target.value, extra_index: name})
                                                        }}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                // For extra seats, move to fare input
                                                                const fareInput = document.querySelector(`input[name="extraSeatDetails[${name}].extra_fare"]`);
                                                                if (fareInput) {
                                                                    fareInput.focus();
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>}
                                            <Col>
                                                <Form.Item
                                                    label={isShowLabel?<strong>Fare</strong>:null}
                                                    {...restField}
                                                    name={[name, 'extra_fare']}
                                                    fieldKey={[fieldKey, 'extra_fare']}
                                                    rules={[{ required: true, message: 'Please enter fare number' }]}
                                                >
                                                    <InputNumber placeholder="Fare" className="ageInput"
                                                        onChange={(value)=>{
                                                            onExtraSeatFormChange({extra_fare:value, extra_index: name})
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Form.Item
                                                    label={isShowLabel?<strong>Remarks</strong>:null}
                                                    {...restField}
                                                    name={[name, 'extra_remarks']}
                                                    fieldKey={[fieldKey, 'extra_remarks']}
                                                    rules={[{ required: true, message: 'Please enter remarks' }]}
                                                >
                                                    <Input placeholder="Remarks"
                                                        className="passengerNameInput"
                                                        onChange={(e)=>{
                                                            onExtraSeatFormChange({extra_remarks:e.target.value, extra_index: name})
                                                        }}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                navigateToNextExtraSeatOrBoardingPoint(name);
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <DeleteOutlined
                                                    style={{marginTop:35, fontSize: 25, color: 'red'}}
                                                    onClick={() => dispatch(updateExtraSeatCount(false,1,name))}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            })}
                        </>
                    )}
                </Form.List>
            </div>
            }
            <Row gutter={16} className="phone-number-block">
                <Col>
                <Form.Item
                    label={<strong>Boarding Point</strong>}
                    name="boardingPointId"
                    tooltip="Please select boarding point"
                    rules={[{ required: boardingDropManditory, message: 'Please select boarding point' }]}
                >
                        <Select
                                ref={boardingPointRef}
                                size="large"
                                showSearch
                                onClick={()=>{
                                    dropPointRef.current?.blur();
                                }}
                                placeholder="Select a Boarding Point"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                        option.searchValue.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                bordered={true}
                                className="boarding-point-select-style"
                                popupClassName="defalut-select-drop-down"
                                onChange={(value) => {
                                    // Auto-navigate to drop point after boarding point selection
                                    if (value) {
                                        setTimeout(() => {
                                            if (dropPointRef.current) {
                                                dropPointRef.current.focus();
                                            }
                                        }, 200);
                                    }
                                }}
                                >
                                {renderBoardingsPoints(stopPoint.pickupDetails,selectedDate)}
                        </Select>
                </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        label={<strong>Drop Point</strong>}
                        tooltip="Please select drop point"
                        rules={[{ required: boardingDropManditory, message: 'Please select drop point' }]}
                        name="dropPointId"
                    >
                        <Select
                                    ref={dropPointRef}
                                    size="large"
                                    showSearch
                                    onClick={()=>{
                                        boardingPointRef.current?.blur();
                                    }}
                                    placeholder="Select a Drop Point"
                                    optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.searchValue.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    bordered={true}
                                    className="drop-point-select-style"
                                    onChange={(value) => {
                                        // Auto-navigate to next field after drop point selection
                                        if (value) {
                                            setTimeout(() => {
                                                navigateToNextFieldAfterDropPoint();
                                            }, 300);
                                        }
                                    }}
                                    >
                                    {renderDropPoints(stopPoint.dropDetails,selectedDate,selectedSchedule)}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                {global.useRemarks === 1 && checkActionAllowed(ACTION_UPDATE_TICKET_REMARKS) &&<Col>
                    <Form.Item
                        label={<strong>Remarks</strong>} 
                        rules={[
                            { required: false, message: 'Please enter remarks' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (!value || (value.length < 50)) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error(`Remarks cannot be greater than 50 characters.`));
                                },
                              })
                        ]}
                        tooltip="Please enter remarks"
                        name="remarks"
                     >
                        <Input placeholder="Remarks" ref={remarksRef} className="defalut-input-style"/>
                    </Form.Item>
                </Col>}
                {!hideEmailFromBooking&&<Col>
                    <Form.Item
                        label={<strong>Email ID</strong>}
                        tooltip="Please enter customer email id"
                        name="emailId"
                    >
                        <Input placeholder="Email ID" className="defalut-input-style"/>
                    </Form.Item>
                </Col>}
                {showVIPTicketReason&&isValidArrayWithValues(vipTicketReasons)&&<Col>
                    <Form.Item
                        label={<strong>VIP Ticket Reason</strong>}
                        name="vip_reason"
                        rules={[{ required: true, message: 'Please select VIP ticket reason' }]}
                    >
                        <Select placeholder="VIP Ticket Reason" className="defalut-input-style" showSearch optionFilterProp="children">
                            {vipTicketReasons.map((reason, index) => (
                                <Option key={index} value={reason}>{reason}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>}
            </Row>
            {isDiscountExits&&
             <Row align="middle">  
                <Col>
                    <Text strong >Ticket Fare : </Text>{baseFare}
                </Col>
                {discountValue > 0 &&
                    <Col>
                        <AddDiscount 
                            baseFare={baseFare}
                            seatCount={isValidArray(seats) ? seats.length : 0}
                            discountValue={discountValue}
                            setDiscountValue={setDiscountValue}
                        />
                    </Col>
                }
            </Row>
            }
            {discountValue>0&&
                <Row align='middle'>
                    <Col>
                        <Text strong>Discount : </Text>{discountValue}
                    </Col>
                    <Col>
                        <EditDiscount 
                            baseFare={baseFare}
                            seatCount={isValidArray(seats) ? seats.length : 0}
                            discountValue={discountValue}
                            setDiscountValue={setDiscountValue}
                        />
                    </Col>
                </Row>
            }
            <Row align='middle'>
                    <Col>
                        <Text strong>
                            {isDiscountExits?"Discounted ":''}Ticket Fare : 
                        </Text>
                        {discountedCostWithoutGst}
                    </Col>
                    {!isDiscountExits&&
                        <Col>
                            <AddDiscount 
                                baseFare={baseFare}
                                seatCount={isValidArray(seats) ? seats.length : 0}
                                discountValue={discountValue}
                                setDiscountValue={setDiscountValue}
                            />
                        </Col>
                    }
            </Row>
            <Row>
                <Col>
                    <Text strong>CGST : </Text>{cgst}
                </Col>
            </Row>
            <Row>
                <Col>
                    <Text strong>SGST : </Text>{sgst}
                </Col>
            </Row>
            <Row align='middle'>
                <Col>
                    <Text strong>Amount Paid : </Text>{totalCost} 
                </Col>
            </Row>
            <Row gutter={[16,16]}>
                {checkFormActionAllowed(ACTION_BOOK_TICKET_ALLOWED)&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                            <CustomModal
                                buttonName={bookButtonType}
                                buttonClassName={"book-button"}
                                onButtonClick={(e)=>{
                                    return handleSubmit(e,bookButtonType);
                                }}
                                children={<ConfirmBody buttonType={bookButtonType} setSendNotification={setSendNotification} sendNotification={sendNotification}/>}
                                onOk={bookAction}
                                okButtonName={bookButtonType}
                            />
                    </Col>
                }
                {checkFormActionAllowed(ACTION_BLOCK_TICKET_ALLOWED)&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                            <CustomModal
                                buttonName={blockButtonType}
                                buttonClassName={'block-button'}
                                onButtonClick={(e)=>{
                                    return handleSubmit(e,blockButtonType);
                                }}
                                children={<ConfirmBody
                                    buttonType={blockButtonType}
                                    isShowMins={checkFormActionAllowed(ACTION_PHONE_BLOCK_ALLOWED)?true:false}
                                />}
                                onOk={blockAction}
                                okButtonName={blockButtonType}
                            />
                    </Col>
                }
                {global.travelsAppConfig['ENABLE_UPI_BOOKING']==1&&checkFormActionAllowed(ACTION_UPI_BOOKING)&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                            <UpiBookingComponent
                                selectedSchedule={selectedSchedule}
                                form={form}
                                discountValue={discountValue}
                                ticketId={ticketId}
                                totalCost={totalCost}
                                onSuccess={onSuccess}
                            />
                    </Col>
                }
                {!hideActionsForRestrictedPrivilege&&
                <BlockByAdminComponent
                        selectedSchedule={selectedSchedule}
                        onSuccess={onSuccess}
                        selectedSeats={seats}
                        disableAdminBlock={disableSetPrice}
                        checkTripActionAllowed={checkFormActionAllowed}
                    />
                }
                {isAnyBlockedSeatExits&&(!hideActionsForRestrictedPrivilege||checkActionAllowed(ACTION_RELEASE_OTA_TICKETS_ALLOWED))&&
                    <Col>
                         <ReleaseSeatsComponent
                            selectedSchedule={selectedSchedule}
                            onSuccess={onSuccess}
                            selectedSeats={seats}
                         />
                    </Col>
                }
                {checkFormActionAllowed(ACTION_PHONE_BLOCK_ALLOWED)&&isSendPhonePaymentLink&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                             <CustomModal
                                 buttonName={sendPaymentLink}
                                 buttonClassName={'payment-link-btn'}
                                 onButtonClick={(e)=>{
                                     return handleSubmit(e,sendPaymentLink);
                                 }}
                                 children={<ConfirmBody buttonType={sendPaymentLink} isShowMins={true}/>}
                                 onOk={blockAction}
                                 okButtonName={sendPaymentLink}
                             />
                     </Col>
                }
                {checkFormActionAllowed(ACTION_PHONE_BLOCK_ALLOWED)&&isPhoneBlockSeat?
                    <Col>
                        <CopyPaymentLink />
                    </Col>
                    :null
                }
                {showPassengerDetails&&!hideActionsForRestrictedPrivilege&&(!isCrossOperatorTrip||checkFormActionAllowed(ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL))&&<Col>
                    <SeatPriceComponent
                        travelDate={selectedDate}
                        tripStartDate = {selectedSchedule.trip_start_date}
                        scheduleId={selectedSchedule.schedule_id}
                        bus={selectedSchedule.bus}
                        description={selectedSchedule.description}
                        selectedSeats={seats}
                        onSuccess={(msg)=>{
                            message.success(msg);
                            onFareUpdateSuccess(selectedSchedule.trip_route_id);
                        }}
                        disableSetPrice={disableSetPrice}
                    />
                </Col>}
                {showPassengerDetails&&checkFormActionAllowed(ACTION_TO_VIEW_SET_GENDER_BTN)&&!hideActionsForRestrictedPrivilege?
                <Col>
                    <ChangeGenderReservation
                        disableSetPrice={disableSetPrice}
                        selectedSeats={seats}
                        tripId={selectedSchedule.trip_id}
                        onSuccess={onSuccess}
                    />
                </Col>
                :null
                }
                {isValid(ticketId)&&selectedSeatStatus=="Blocked"&&isValid(boardingId)&&(isValid(dropId))&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                        <SeatClickTicketPopUp
                            ticketId={[ticketId]}
                            seatNumber={seats[0].seat_number}
                            agentId={seats[0].agent_id}
                            isButtonClick={true}
                            buttonText="Update"
                        ></SeatClickTicketPopUp>
                    </Col>
                }
                {isValid(ticketId)&&selectedSeatStatus=="Blocked"&&!hideActionsForRestrictedPrivilege&&
                    <Col>
                        <Button className="modify-button" onClick={goToModifyCancelByTicketId}>
                            Modify
                        </Button>
                    </Col>
                }
            </Row>
        </Form>
         <div>
                {isPhoneBlockSeat&&
                    <h3>Release Time : {getLocalDateAndTime(timeOfRelease)}</h3>
                }
        </div>
    </div>
  );
};